module.exports = __webpack_public_path__ + "static/media/personal.3d4fbf06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/personal.jpg
// module id = 957
// module chunks = 0